import _objectWithoutProperties from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["children", "elementType", "isFocusable", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mergeProps as $hZMlr$mergeProps } from "@react-aria/utils";
import $hZMlr$react, { useState as $hZMlr$useState, useMemo as $hZMlr$useMemo } from "react";
import { useFocus as $hZMlr$useFocus } from "@react-aria/interactions";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $2b1a1e0abf5e6e14$exports = {};
$parcel$export($2b1a1e0abf5e6e14$exports, "useVisuallyHidden", function () {
  return $2b1a1e0abf5e6e14$export$a966af930f325cab;
});
$parcel$export($2b1a1e0abf5e6e14$exports, "VisuallyHidden", function () {
  return $2b1a1e0abf5e6e14$export$439d29a4e110a164;
});
var $2b1a1e0abf5e6e14$var$styles = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  margin: '0 -1px -1px 0',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  width: 1,
  whiteSpace: 'nowrap'
};

function $2b1a1e0abf5e6e14$export$a966af930f325cab() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var style = props.style,
      isFocusable = props.isFocusable;

  var _$hZMlr$useState = $hZMlr$useState(false),
      _$hZMlr$useState2 = _slicedToArray(_$hZMlr$useState, 2),
      isFocused = _$hZMlr$useState2[0],
      setFocused = _$hZMlr$useState2[1];

  var _$hZMlr$useFocus = $hZMlr$useFocus({
    isDisabled: !isFocusable,
    onFocusChange: setFocused
  }),
      focusProps = _$hZMlr$useFocus.focusProps; // If focused, don't hide the element.


  var combinedStyles = $hZMlr$useMemo(function () {
    if (isFocused) return style;else if (style) return _objectSpread(_objectSpread({}, $2b1a1e0abf5e6e14$var$styles), style);else return $2b1a1e0abf5e6e14$var$styles;
  }, [isFocused]);
  return {
    visuallyHiddenProps: _objectSpread(_objectSpread({}, focusProps), {}, {
      style: combinedStyles
    })
  };
}

function $2b1a1e0abf5e6e14$export$439d29a4e110a164(props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var children = props.children,
      _props$elementType = props.elementType,
      Element = _props$elementType === void 0 ? 'div' : _props$elementType,
      isFocusable = props.isFocusable,
      style = props.style,
      otherProps = _objectWithoutProperties(props, _excluded);

  var _$2b1a1e0abf5e6e14$ex = $2b1a1e0abf5e6e14$export$a966af930f325cab(props),
      visuallyHiddenProps = _$2b1a1e0abf5e6e14$ex.visuallyHiddenProps;

  return /*#__PURE__*/$hZMlr$react.createElement(Element, $hZMlr$mergeProps(otherProps, visuallyHiddenProps), children);
}

export { $2b1a1e0abf5e6e14$export$a966af930f325cab as useVisuallyHidden, $2b1a1e0abf5e6e14$export$439d29a4e110a164 as VisuallyHidden };